import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let appInsightsInstance = null;

const sanitizeValue = (value) => {
  if (typeof value === 'string') {
    let sanitized = value;
    sanitized = sanitized.replace(/\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g, '[email]');
    sanitized = sanitized.replace(/\b\d{3}[-.\s]?\d{3}[-.\s]?\d{4}\b/g, '[phone]');
    sanitized = sanitized.replace(/\b(?:\d[ -]*?){13,16}\b/g, '[card]');
    if (sanitized.length > 200) {
      sanitized = `${sanitized.slice(0, 197)}...`;
    }
    return sanitized;
  }

  if (Array.isArray(value)) {
    return value.map((item) => sanitizeValue(item));
  }

  if (typeof value === 'object' && value !== null) {
    return Object.keys(value).reduce((acc, key) => {
      acc[key] = sanitizeValue(value[key]);
      return acc;
    }, {});
  }

  return value;
};

const getConnectionString = () => {
  if (process.env.REACT_APP_APPLICATION_INSIGHTS_KEY) {
    return process.env.REACT_APP_APPLICATION_INSIGHTS_KEY;
  }

  if (process.env.REACT_APP_APPLICATION_INSIGHTS_CONNECTION_STRING) {
    return process.env.REACT_APP_APPLICATION_INSIGHTS_CONNECTION_STRING;
  }

  if (process.env.REACT_APP_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY) {
    return `InstrumentationKey=${process.env.REACT_APP_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY}`;
  }

  return '';
};

export const getAppInsights = () => {
  if (appInsightsInstance) {
    return appInsightsInstance;
  }

  const connectionString = getConnectionString();

  if (!connectionString) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Application Insights connection string not configured.');
    }
    return null;
  }

  appInsightsInstance = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: false,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: false,
      enableResponseHeaderTracking: false,
      disableAjaxTracking: true
    }
  });

  appInsightsInstance.loadAppInsights();

  return appInsightsInstance;
};

export const trackTelemetryEvent = (name, properties = {}) => {
  const client = getAppInsights();
  if (!client) {
    return;
  }

  client.trackEvent({ name }, sanitizeValue(properties));
};

export const flushTelemetry = () => {
  const client = getAppInsights();
  if (client) {
    client.flush();
  }
};

export const maskPII = sanitizeValue;
